import type { SVGProps } from 'react'
const IconPen2BoldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.066 12.908a.677.677 0 0 0-.675.675.67.67 0 0 0 .675.675.677.677 0 0 0 .675-.675.684.684 0 0 0-.675-.675"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.41 14.818c.482-.473.55-1.215.154-1.784L12.95 9.393a.32.32 0 0 0-.352-.114 4 4 0 0 1-.264.072 3.6 3.6 0 0 1-.549.067H6.337a3.6 3.6 0 0 1-.55-.067 4 4 0 0 1-.255-.07.33.33 0 0 0-.368.112l-2.607 3.64a1.37 1.37 0 0 0 .174 1.785c1.07 1.022 3.722 3.654 5.14 6.18q.037.064.08.126c.139.188.391.058.391-.176v-5.16a.33.33 0 0 0-.193-.29 2.12 2.12 0 0 1-1.205-1.914c0-1.167.955-2.121 2.122-2.121s2.121.954 2.121 2.12c0 .843-.489 1.57-1.204 1.914a.33.33 0 0 0-.194.292v5.136c0 .237.257.366.393.172q.037-.052.07-.11c1.494-2.64 4.32-5.388 5.158-6.17M4.438 6.96a2.09 2.09 0 0 0 1.456 1.416c.173.05.357.078.54.078h5.264c.183 0 .367-.029.53-.078a2.05 2.05 0 0 0 1.456-1.417l.357-1.234a1.8 1.8 0 0 0-.3-1.62 1.81 1.81 0 0 0-1.474-.742H5.855a1.81 1.81 0 0 0-1.465.742 1.8 1.8 0 0 0-.3 1.62zM20.945 20.155c-.961 0-1.41-.162-1.931-.349-.57-.205-1.215-.438-2.44-.438-1.222 0-1.867.232-2.437.438-.52.187-.968.35-1.93.35a.75.75 0 0 0 0 1.5c1.223 0 1.869-.234 2.439-.439.52-.187.968-.349 1.928-.349.963 0 1.412.162 1.933.35.569.205 1.215.437 2.438.437a.75.75 0 0 0 0-1.5"
      clipRule="evenodd"
    />
  </svg>
)
export default IconPen2BoldIcon
